module.exports = __webpack_public_path__ + "static/media/welcome.04b74054.jpg";